import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// The candidate's own page: the Bearbeiten link in the shared dialog, and the
// delete button on the Stammdaten section.
//
// Nothing else - the proposals are read-only here (they are acted on from the
// job), the documents are dokumentInline.js, and the Verlauf column is the
// shared kundeVerlauf module now that it reads its parent from the dataset.
export function initKandidatDetail() {
  // Also on the detail page, so "Bearbeiten" opens the dialog rather than
  // navigating. Looks up its own links and returns early when there are none.
  initFormModalLinks();

  const button = document.getElementById('kandidat-loeschen');
  if (!button) return;

  button.addEventListener('click', async () => {
    const { id, name } = button.dataset;

    const confirmed = await confirmAction({
      title: 'Kandidat löschen',
      message: `Möchten Sie ${name} endgültig löschen? Das kann nicht rückgängig gemacht werden.`,
      okText: 'Löschen'
    });
    if (!confirmed) return;

    button.disabled = true;
    showLoading('Kandidat wird gelöscht …');

    try {
      await http.delete(`/kandidaten/${id}`);
      window.location.href = withFlash('/kandidaten', 'kandidat-geloescht');
    } catch (err) {
      hideLoading();
      button.disabled = false;
      // The 409 for a candidate who has been proposed carries the sentence that
      // explains itself - "setzen Sie ihn stattdessen auf inaktiv" - so the
      // server's message is shown as-is rather than replaced with a generic one.
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
